<div class="dropdown">
  <div class="dropdown-header flex items-center justify-between">
    <div class="flex items-center">
      <div class="dropdown-heading-icon flex items-center justify-center">
        <mat-icon svgIcon="mat:person"></mat-icon>
      </div>
      <div>
        <div class="dropdown-heading">{{ usuarioLogado()?.nome }}</div>
        <div class="text-xs">
          {{ perfilUsuarioLogado()?.nome }}
        </div>
      </div>
    </div>
  </div>

  <div class="dropdown-content">
    @for (item of items; track trackById($index, item)) {
      <a
        (click)="close()"
        [routerLink]="item.route"
        class="notification flex items-center"
        matRipple
        >
        <mat-icon
          [ngClass]="item.colorClass"
          [svgIcon]="item.icon"
          class="notification-icon flex-none"
        ></mat-icon>
        <div class="flex-auto">
          <div class="notification-label">{{ item.label }}</div>
          <div class="notification-description">{{ item.description }}</div>
        </div>
        <mat-icon
          class="notification-chevron flex-none"
          svgIcon="mat:chevron_right"
        ></mat-icon>
      </a>
    }
  </div>

  <div class="dropdown-footer flex items-center justify-end">
    <a
      (click)="logout()"
      class="notification flex items-center slc-btn-text-brand"
      mat-button
      >
      <mat-icon
        svgIcon="mat:exit_to_app"
        class="flex-none text-primary-600 mr-2"
      ></mat-icon>
      <span class="flex-none text-primary-600">Sair</span>
    </a>
  </div>
</div>
